var components = {'uniIcons': require('@/components/uni-icons/uni-icons.vue').default}
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('uniBadge',{staticClass:"badge-cart",attrs:{"size":"small","text":_vm.cartText,"absolute":"rightTop","type":"error"}},[_c('uni-icons',{attrs:{"size":"32","type":"icomoon-cart"}})],1)}
var recyclableRender = false
var staticRenderFns = []

export { render, staticRenderFns, recyclableRender, components }